'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withButtonWidth = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['min-width: ', ';'], ['min-width: ', ';']);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultWith = '120px';

var withButtonWidth = exports.withButtonWidth = function withButtonWidth(_ref) {
  var width = _ref.width;
  return (0, _styledComponents.css)(_templateObject, width || defaultWith);
};

exports.default = withButtonWidth;